import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutlined';
import { Box, Button, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import {
  COURT_CASES_DATE_COLUMN_INDEXES,
  COURT_CASES_TABLE_ARIA_LABEL,
  COURT_CASES_TABLE_COLUMN_WIDTHS,
  COURT_CASES_TABLE_HEADERS,
  COURT_CASES_TABLE_MIN_WIDTH,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/courtCases/constants.ts';
import { CourtCaseRow } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/courtCases/CourtCaseRow.tsx';
import { FinancialConditionTable } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTable.tsx';
import type { ICourtCasesSectionProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/courtCases/types.ts';
import type { TFinancialConditionFormValues } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { createCourtCase } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

export const CourtCasesSection: React.FC<ICourtCasesSectionProps> = ({
  disabled,
  borrowerType,
  sectionNumber,
}) => {
  const { control, watch } = useFormContext<TFinancialConditionFormValues>();
  const currentBorrowerType = watch('borrowerType')?.value;
  const { fields, append, remove } = useFieldArray({ control, name: 'courtCases' });

  if (currentBorrowerType !== borrowerType) {
    return null;
  }

  return (
    <Box sx={documentGenerationFormStyles.section}>
      <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
        {sectionNumber}. Судові справи
      </Typography>
      <FinancialConditionTable
        ariaLabel={COURT_CASES_TABLE_ARIA_LABEL}
        headers={[...COURT_CASES_TABLE_HEADERS]}
        showActions={fields.length > 1}
        dateColumnIndexes={[...COURT_CASES_DATE_COLUMN_INDEXES]}
        columnWidths={[...COURT_CASES_TABLE_COLUMN_WIDTHS]}
        minWidth={COURT_CASES_TABLE_MIN_WIDTH}
      >
        {fields.map((field, index) => (
          <CourtCaseRow
            key={field.id}
            index={index}
            canRemove={fields.length > 1}
            disabled={disabled}
            onRemove={() => remove(index)}
          />
        ))}
      </FinancialConditionTable>
      <Button
        variant="outlined"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => append(createCourtCase())}
        disabled={disabled}
        sx={documentGenerationFormStyles.addButton}
      >
        Додати судову справу
      </Button>
    </Box>
  );
};
